var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeRt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.9699993mm",
    height: "7.0008998mm",
    viewBox: "0 0 6.9699995 7.0009",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-77.933,-113.42)",
    id: "g3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 84.77,118.71 v -4.201 c 0,-0.53065 -0.42743,-0.95808 -0.95808,-0.95808 h -4.7889 c -0.53065,0 -0.95808,0.42743 -0.95808,0.95808 v 4.201",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.26458,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 11.411,
      paintOrder: "stroke markers fill"
    },
    id: "path1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 81.342201,
    y: 120.40054,
    style: {
      fontSize: "1.5524px",
      lineHeight: 0,
      fontFamily: "Univers",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.0089677px"
    },
    xmlSpace: "preserve",
    id: "text1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81.342201,
    y: 120.40054,
    style: {
      fontWeight: 500,
      fontFamily: "Figtree",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#000000",
      stroke: "none",
      strokeWidth: "0.0089677px"
    },
    id: "tspan1"
  }, "RT")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82352,0,0,0.82587,7.3384,20.881)",
    style: {
      strokeWidth: 1.2126
    },
    id: "g2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 89.955,117.05 1.1075,-1.1076 -3.65e-4,-3.6e-4 a 1.5663,1.5663 0 0 0 3.63e-4,-2.2147 1.5663,1.5663 0 0 0 -2.2151,0 1.5663,1.5663 0 0 0 2e-6,2.2151 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.32083,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDashoffset: 11.411,
      paintOrder: "stroke markers fill"
    },
    id: "path2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.955002,
    cy: 114.84,
    r: 0.38874,
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      paintOrder: "stroke markers fill"
    },
    id: "circle2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeRt);
export default __webpack_public_path__ + "static/media/icon_type_rt.c81a6c58871e58156d95a769f801ddf6.svg";
export { ForwardRef as ReactComponent };